import { Tag } from '@cian/components';
import * as React from 'react';

import { IWordsExcludeTag } from '../../../state/tags/definitions/words_exclude';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWordsExcludeTagItemProps {
  tag: IWordsExcludeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WordsExcludeTagItem = ({ tag, onDeleteClick, withNewTag }: IWordsExcludeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Не содержит "{tag.value}"
    </TagComponent>
  );
};
